import React from "react";

import { useSetLocationData } from "~/hooks/locationData";

import Button from "~/shared/ui/Fields/Button";

import Search from "~/components/Icons/icon-search";

import s from "./TableRow.less";
import { usePermissions } from "~/shared/context/PermissionContext";

interface IProps {
  options: string[];
  optionChildren: string[];
  item;
}

const QTableRow: React.FC<IProps> = ({
  options = [],
  optionChildren = [],
  item = {},
}) => {
  const { hasPermission, loading: loadingPermissions } = usePermissions();
  const setData = useSetLocationData();
  const openViewModal = () => {
    setData("openChildModal", "View", "currentId", item.id);
  };

  return (
    <>
      <tr className={s.row_tr}>
        {options?.map((optionName) => (
          <td
            style={{
              backgroundColor:
                options.includes("button") &&
                (item.type === "header"
                  ? item.ParentId !== null
                    ? "#E7E8EA"
                    : "#FBC78E"
                  : optionChildren.includes(optionName)
                  ? (item.GroupIndicatorId.trim() === "I" && "#B2D363") ||
                    (item.GroupIndicatorId.trim() === "II" && "#FFDE5A") ||
                    (item.GroupIndicatorId.trim() === "III" && "#FA9863") ||
                    (item.GroupIndicatorId.trim() === "IV" && "#FF747C")
                  : ""),
              height: item.type === "header" && "27px",
            }}
            key={optionName}
            data-option_name={optionName}
          >
            <div className={s.cont}>
              {item.type === "header" &&
              options.includes("button") &&
              optionChildren.includes(optionName)
                ? ""
                : item.type !== "header" && optionName === "button"
                ? hasPermission("quartilesRatings.ratingDataByLine.get") && (
                    <Button
                      onlyIcon
                      onClick={openViewModal}
                      customClassName={s.search}
                    >
                      <Search width="20" height="20" />
                    </Button>
                  )
                : item[optionName]}
            </div>

            {optionChildren.length > 0 &&
              optionChildren.includes(optionName) && (
                <div className={s.cont_under}>
                  {item[optionName + "Period"]}
                </div>
              )}
          </td>
        ))}
      </tr>
    </>
  );
};
export default QTableRow;
